/* unplugin-vue-components disabled */
export default {
  emits: ['submit', 'deleted'],
  data() {
    return {
      tracker: undefined,
      loading: false
    }
  },
  computed: {
    persona_count() {
      return this.tracker.contacts?.length
    },
    pluralized() {
      if (this.persona_count > 50) {
        return 'over 50 persona trackers'
      }
      return $utils.str.pluralize(this.persona_count, 'persona tracker')
    },
  },
  methods: {
    open(tracker) {
      this.loading = false
      this.tracker = tracker
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    async deleteTracker(){
      this.loading = true
      await this.tracker.drop()
      this.$emit('deleted', this.tracker)
      this.close()
      $utils.toasts.success(`Tracker <b>${this.tracker.name}</b> has been deleted.`)
      this.$dispatch('delete-tracker', this.tracker)
    }
  }
}
